import Popup from 'react-popup'
import './popup.scss'

/**
 * Open a confirm popup using react-popup
 * showing a message and a Cancel and Ok button.
 *
 * @param {Object} options
 * @property {string} title
 * @property {string} message
 * @property {string} [okText]
 * @property {string} [okClassName]
 * @property {function () : undefined} [onOk]
 */
export function alertPopup({ title, message, okText, okClassName, onOk }) {
  const bringToFront = true

  Popup.create(
    {
      title: title || 'Alert',
      content: message,
      className: 'alert',
      buttons: {
        left: [],
        right: [
          {
            text: okText || 'Ok',
            className: okClassName || 'ok',
            key: 'esc',
            action: () => {
              Popup.close()

              if (onOk) {
                onOk()
              }
            }
          }
        ]
      }
    },
    bringToFront
  )
}
